import React, { useState, useEffect } from 'react';
import { pick } from 'ramda';
import { useDeviceSelector as useDevice } from 'js/store/hooks';
import { ManagedPopup } from 'js/components/common/Popup';
import { dispatcher } from 'dispatcher';
import GamesWheel from './GamesWheel';
import GameCard from './GameCard';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import style from './IFeelLuckyPopup.scss';

export const popupClassNames = {
    inner: style.popupInner,
    close: style.closeBtn,
    container: style.popupContainer
};

export const gameWheelClassNames = {
    active: style.selectedGame
};

export const DELAY_BEFORE_SHOWING_CARD = 1500;

const layerClassNames = {
    layout: style.layout,
    overlay: style.overlay
};

export const LuckyPopup = ({ id, onClose, uniqueGame }) => {
    const [currentGameItem, setCurrentGameItem] = useState(null);
    const [isWheelHidden, hideWheel] = useState(false);
    const { isDesktop, browserName } = useDevice(pick(['isDesktop', 'browserName']));
    const onGameLaunched = isDesktop ? onClose : null;
    const closePopup = useCombinedOnClose(onClose, id);

    useEffect(() => {
        dispatcher.listen('route:changed', onClose);
        dispatcher.listen('auth:login', closePopup);

        return () => {
            dispatcher.removeListener('route:changed', onClose);
            dispatcher.removeListener('auth:login', closePopup);
        };
    }, []);

    useEffect(() => {
        let timeoutId;

        if (currentGameItem) {
            timeoutId = setTimeout(() => hideWheel(true), DELAY_BEFORE_SHOWING_CARD);
        } else {
            hideWheel(false);
        }

        return () => clearTimeout(timeoutId);

    }, [currentGameItem]);

    return (
        <ManagedPopup
            id={id}
            title={null}
            controls={null}
            layerClassNames={layerClassNames}
            onClose={closePopup}
            className={style.popup}
            classNames={popupClassNames}
        >
            <div className={style.content}>
                {
                    isWheelHidden
                        ? currentGameItem && <GameCard {...currentGameItem}
                                                       setCurrentGameItem={setCurrentGameItem}
                                                       onGameLaunched={onGameLaunched} />
                        : <GamesWheel currentGameItem={currentGameItem}
                                      setCurrentGameItem={setCurrentGameItem}
                                      classNames={gameWheelClassNames}
                                      browserName={browserName}
                                      games={uniqueGame} />
                }
            </div>
        </ManagedPopup>
    );
};
